import { useStore } from '@store/index';
import React, { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { sanitizeRedirectUrl } from '@/utils/urlValidation';

/** Public routes (login): authenticated users are sent on to their redirect target. */
export const PublicRoute = ({ children }: { children: ReactNode }) => {
  const { isAuthenticated } = useStore();
  const location = useLocation();

  if (isAuthenticated && location.pathname === '/login') {
    // Same source and sanitizer as useAuth's completeLogin.
    const params = new URLSearchParams(location.search);
    const target = sanitizeRedirectUrl(params.get('redirect') || location.state?.from?.pathname);
    return <Navigate to={target} replace />;
  }

  return <>{children}</>;
};
